import { useContext } from "react";
import CurrentUserContext from "core/context/CurrentUserContext";

const useCurrentUser = () => {
  const context = useContext(CurrentUserContext);

  if (context === undefined) {
    throw Error("useCurrentUser must be used within an CurrentUserProvider!");
  }

  return context;
};

export default useCurrentUser;
